export default __webpack_public_path__ + "static/media/login_astro.8ba897ff.png";